export default __webpack_public_path__ + "static/media/minus_icon.87159e67.svg";